@if (scoreboard.started) {
    @for (player of players; track $index; let i = $index) {
        <span class="player-name">{{ i + 1 }}. {{ player.name }}</span>
    }
}
